import { ProductByHandleQuery, ProductPriceRange } from "../sdk";

import { shopifyToIntlPrice } from "./shopifyToIntlPrice";

export const renderPriceRange = (
  priceRange: ProductPriceRange,
  product?: ProductByHandleQuery["productByHandle"]
) => {
  if (
    priceRange?.minVariantPrice.amount === priceRange?.maxVariantPrice.amount
  ) {
    return shopifyToIntlPrice(priceRange?.minVariantPrice);
  }
  if (+priceRange?.minVariantPrice?.amount === 0) {
    const variantPrice = product?.variants?.edges[0]?.node?.priceV2;
    return `${shopifyToIntlPrice(variantPrice)} - ${shopifyToIntlPrice(
      priceRange?.maxVariantPrice
    )}`;
  }
  return `${shopifyToIntlPrice(
    priceRange?.minVariantPrice
  )} - ${shopifyToIntlPrice(priceRange?.maxVariantPrice)}`;
};
